
export type SubscribePlanChangeUpgradeGet200ResponseUpgradeInfo = {
  effectiveDate?: string;
  fromPlan?: string;
  priceDifference?: number;
  toPlan?: string;
};
